export const nav = 1;

export default {
  ["customer-cleanup"]: {
    nav,
    icon: "object-group",
    url: "/customer-cleanup",
    title: "Customer Cleanup",
    templateProvider: $stateParams => `<customer-cleanup />`
  },
};
